import React from 'react';

export function EyeIcon() {
  return (
    <svg className="icon" viewBox="0 0 24 24">
      <path d="M12 5C7 5 2.7 9 1 12c1.7 3 6 7 11 7s9.3-4 11-7c-1.7-3-6-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 
               5-5 5 2.2 5 5-2.2 5-5 5zm0-8a3 3 0 100 6 3 3 0 000-6z"/>
    </svg>
  );
}

export function RefreshIcon() {
  return (
    <svg className="icon" viewBox="0 0 24 24">
      <path d="M17.65 6.35a7.95 7.95 0 00-11.3 0 7.95 7.95 0 000 11.3 8 8 0 0011.3 0h-1.42a6.5 6.5 0 01-9.2-9.2 
               6.5 6.5 0 019.2 0L14 10h6V4l-2.35 2.35z"/>
    </svg>
  );
}

export function BackIcon() {
  return (
    <svg className="icon" viewBox="0 0 24 24">
      <path d="M19 11H7.83l5.58-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H19v-2z"/>
    </svg>
  );
}
